import { TYPES } from 'constants/ChecklistConstants';

export const DEALER_TAB_CHECKLIST_TYPES = {
  parts: TYPES.PARTS,
  sales: TYPES.ACCESSORY,
  afterSales: TYPES.WORKS,
  selfService: TYPES.UPSELLING,
};
